import { estimateMutationScopeId } from '@/api/mutations/estimates/hydrateEstimateCaches';
import useAddEstimateLineItem from '@/api/mutations/estimates/useAddEstimateLineItem';
import InfiniteLineItemsList from '@/ui/components/infiniteLineItemsList/InfiniteLineItemsList';
import AddEditItemSidebar from '@/ui/pages/listedItemsPage/components/AddEditItemSidebar';
import { Button } from '@payaca/ambrosia';
import { clstx } from '@payaca/utilities/cvaMerge';
import { FC, useState } from 'react';

type EstimateItemPickerProps = {
  projectId: string;
  estimateId: string;
  sectionId: string;
  onClose: () => void;
};

const EstimateItemPicker: FC<EstimateItemPickerProps> = (props) => {
  const { projectId, estimateId, sectionId, onClose } = props;

  const [isCreateItemSidebarOpen, setIsCreateItemSidebarOpen] = useState(false);

  const addEstimateLineItem = useAddEstimateLineItem({
    projectId,
    estimateId,
    options: {
      scope: { id: estimateMutationScopeId(estimateId) },
      onSuccess: () => onClose(),
    },
  });

  return (
    <>
      <div className="flex flex-col min-h-0 h-full">
        <div className="px-3.5 pt-3.5">
          <Button onClick={onClose} variant="ghost" colour="grey" size="sm">
            Back to items
          </Button>
        </div>

        <div
          className={clstx(
            'flex min-h-0 flex-1 flex-col transition-opacity',
            addEstimateLineItem.isPending && 'pointer-events-none opacity-60'
          )}
          aria-busy={addEstimateLineItem.isPending}
        >
          <InfiniteLineItemsList
            onCreateNewItem={() => {
              setIsCreateItemSidebarOpen(true);
            }}
            onLineItemClick={(lineItem) => {
              addEstimateLineItem.mutate({
                sectionId,
                lineItemId: lineItem.publicId,
              });
            }}
          />
        </div>
      </div>

      <AddEditItemSidebar
        isOpen={isCreateItemSidebarOpen}
        onClose={() => setIsCreateItemSidebarOpen(false)}
        onCreateSuccess={(lineItemId, lineItemPublicId) => {
          addEstimateLineItem.mutate({
            sectionId,
            lineItemId: lineItemPublicId,
          });
        }}
      />
    </>
  );
};

export default EstimateItemPicker;
